import StaticDashboardContainer from "../shared/StaticDashboardContainer";
import CityGrid from "./CityGrid/CityGrid";
import Generators from "./Generators/Generators";

const PowerSource = () => {
  return (
    <StaticDashboardContainer heading="Current power source">
      <div className="w-full h-full flex flex-col gap-4">
        <div className="flex-1">
          <CityGrid />
        </div>
        <div className="flex-1">
          <Generators />
        </div>
      </div>
    </StaticDashboardContainer>
  );
};

export default PowerSource;